"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPONSE_SET_VIDEO_SETTINGS = exports.REQUEST_SET_VIDEO_SETTINGS = exports.REQUEST_GET_VIDEO_SETTINGS = void 0;
var _messageModel = require("../../../message/messageModel");
// CATEGORIES:

var AETHER_DEFAULTS = 2009;

// REQUESTS:
var REQUEST_GET_VIDEO_SETTINGS = exports.REQUEST_GET_VIDEO_SETTINGS = new _messageModel.RequestMessageDefinition(AETHER_DEFAULTS, 6);
var REQUEST_SET_VIDEO_SETTINGS = exports.REQUEST_SET_VIDEO_SETTINGS = new _messageModel.RequestMessageDefinition(AETHER_DEFAULTS, 7);
var RESPONSE_SET_VIDEO_SETTINGS = exports.RESPONSE_SET_VIDEO_SETTINGS = new _messageModel.RespondMessageDefinition(AETHER_DEFAULTS, 3);